import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const PLACES_PLACE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/places',
        name: '::Menu:Places',
        iconClass: 'fas fa-map-marker',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Places',
        parentName: '::Menu:Configurations',
        order: 2,
      },
    ]);
  };
}
